import {FC, useState} from "react";
import {Flex, Radio, RadioGroupProps} from "antd";
import {EventFilter} from "../../types/domain.ts";
import {useEvents} from "../../queries/useEvents.ts";
import {EventsTable} from "../../components/EventsTable/EventsTable.tsx";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";

export const ArchivePage: FC = () => {
    const { profile } = useOwnProfile();

    const options: RadioGroupProps['options'] = [
        { label: 'Все', value: 'archive' },
        { label: 'Утвержденные', value: 'archive_complete' },
        { label: 'Отмененные', value: 'archive_cancelled' }
    ]

    const [value, setValue] = useState<EventFilter>('archive');
    const { data: events, isLoading, refetch } = useEvents(value);

    return (
        <Flex vertical gap={16} flex="1 0" style={{ width: '100%' }}>
            {profile?.role !== 'fir_reader' && (
                <Flex>
                    <Radio.Group
                        block
                        options={options}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        optionType="button"
                        buttonStyle="solid"
                        size="large"
                    />
                </Flex>
            )}
            <EventsTable
                events={events}
                loading={isLoading}
                onUpdate={refetch}
            />
        </Flex>
    );
}